import { render, staticRenderFns } from "./VantImageUpload.vue?vue&type=template&id=2fe74c21&scoped=true&lang=pug&"
import script from "./VantImageUpload.vue?vue&type=script&lang=ts&"
export * from "./VantImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./VantImageUpload.vue?vue&type=style&index=0&id=2fe74c21&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe74c21",
  null
  
)

export default component.exports